import { render, staticRenderFns } from "./ImportExports.vue?vue&type=template&id=1f43523f&"
import script from "./ImportExports.vue?vue&type=script&lang=js&"
export * from "./ImportExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports